import gql from 'graphql-tag';

export const REGISTER_LEAD_PROVIDER_MUTATION = gql`
  mutation registerLeadProvider(
    $email: String
    $phone: String
    $phoneAlternative: String
    $firstNames: String
    $lastName: String
    $createdByUserId: Int
    $contactCountryCode: String
    $alternativeContactCountryCode: String
    $scheduledDateTime: ISO8601DateTime
  ) {
    registerLeadProvider(
      email: $email
      phone: $phone
      phoneAlternative: $phoneAlternative
      firstNames: $firstNames
      lastName: $lastName
      createdByUserId: $createdByUserId
      contactCountryCode: $contactCountryCode
      alternativeContactCountryCode: $alternativeContactCountryCode
      scheduledDateTime: $scheduledDateTime
    ) {
      statusCode
      message
      numberOfCreatedTestators
      numberOfWillsDownloaded
    }
  }
`;

export const LEAD_PROVIDER_DASHBOARD_QUERY = gql`
  query leadProviderDashboard($id: ID!) {
    leadProviderDashboard(id: $id) {
      numberOfCreatedTestators
      numberOfWillsDownloaded
    }
  }
`;
